import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { trackAction } from '@ctct/distui-helpers';
import { Button, StatusTag, Upsell } from '@ctct/ui-react';

import { useUpgradeContext } from '../UpgradeContext';
import { stepsEnum } from '../utils';

const UpgradeIntroStep = ({ footerContent, footerActions }) => {
  const [upgradeContext, dispatchUpgrade] = useUpgradeContext();
  const { stepOneInformation, upgradeIsTrialer } = upgradeContext;
  const { featureName, header, subHeader, image, featureList } = stepOneInformation;
  const { t } = useTranslation();

  if (!footerContent && !footerActions)
    // content
    return (
      <Upsell
        image={{ url: image, alt: t('intro-image-alt') }}
        data-qe-id="upgrade-intro-upsell"
        overline={
          <>
            <span className="intro-plan-name">{featureName}</span>
            <StatusTag
              className="intro-recommended-tag"
              text={t('upgrade-popup.upgrade-required')}
              kind="featured"
              data-qe-id="status-tag-recommended"
            />
          </>
        }
        heading={header}
        text={subHeader}
        testimonials={featureList}
        isReversed
        backgroundColor="white"
      />
    );

  // footerContent
  if (!footerActions) {
    return null;
  }

  // footerActions
  return (
    <>
      {!upgradeIsTrialer && <span className="step">{t('upgrade-popup.step-1')}</span>}
      <Button
        shape="pill"
        data-qe-id="maybe-later-button"
        text={t('upgrade-popup.button-text.maybe-later')}
        onClick={() => {
          trackAction({
            action: 'Clicked Maybe later button',
          });
          dispatchUpgrade({ type: 'setUpgradeStep', value: stepsEnum.CLOSE });
        }}
      />
      <Button
        shape="pill"
        data-qe-id="upgrade-intro-continue-to-upgrade"
        text={t(upgradeIsTrialer ? 'upgrade-popup.button-text.buy-now' : 'upgrade-popup.button-text.view-pricing')}
        kind="primary"
        onClick={() => {
          dispatchUpgrade({ type: 'setUpgradeStep', value: stepsEnum.UPGRADE });
        }}
      />
    </>
  );
};

UpgradeIntroStep.defaultProps = {
  footerContent: false,
  footerActions: false,
};

UpgradeIntroStep.propTypes = {
  footerContent: PropTypes.bool,
  footerActions: PropTypes.bool,
};

export default UpgradeIntroStep;
